// extracted by css-extract-rspack-plugin
export default {"backButton":"_dcbb4827","translucentWhite":"_fbda2ac2","backButtonDisabled":"_d4dd8d57"};